module.exports = __webpack_public_path__ + "static/media/bizamaps.40324371.jpeg";